(function (
    DEFAULT_CDN_PREFIX,   
    STRING_WEB_COMPONENTS_REQUESTED,
    WINDOW,
    DOCUMENT,
    init
) {
    /**
     * A Custom Elements (Web Components) polyfill loader wrapper.
     * Use it to wrap modules that use CEs and it will take care of
     * only executing the module initialization function when the
     * polyfill is loaded.
     * This loader wrapper also loads the `core-js` library if it
     * finds that he current environment does not support Promises
     * (ex. IE)
     *
     * The loader contains default URLs for polyfills, however, these
     * can be overwritten with the following globals:
     *
     * -    `window.WEB_COMPONENTS_POLYFILL`
     * -    `window.ES6_CORE_POLYFILL`
     *
     * In addition, this loader will add the following global
     * variable, which is used to store module initialization
     * functions until the environment is patched:
     *
     * -    `window.AWAITING_WEB_COMPONENTS_POLYFILL`: an Array 
     *      with callbacks. To store a new one, use
     *      `window.AWAITING_WEB_COMPONENTS_POLYFILL.then(callbackHere)`
     */
    if (!('customElements' in WINDOW)) {
        
        // If in the mist of loading the polyfills, then just add init to when that is done
        if (WINDOW[STRING_WEB_COMPONENTS_REQUESTED]) {
            WINDOW[STRING_WEB_COMPONENTS_REQUESTED].then(init);
            return;
        }
        
        var _WEB_COMPONENTS_REQUESTED = WINDOW[STRING_WEB_COMPONENTS_REQUESTED] = getCallbackQueue();
        _WEB_COMPONENTS_REQUESTED.then(init);
        
        var WEB_COMPONENTS_POLYFILL = WINDOW.WEB_COMPONENTS_POLYFILL || "/" + "/" + DEFAULT_CDN_PREFIX + "/webcomponentsjs/2.0.2/webcomponents-bundle.js";
        var ES6_CORE_POLYFILL = WINDOW.ES6_CORE_POLYFILL || "/" + "/" + DEFAULT_CDN_PREFIX + "/core-js/2.5.3/core.min.js";
        
        if (!("Promise" in WINDOW)) {
            loadScript(ES6_CORE_POLYFILL)
                .then(function () {
                    loadScript(WEB_COMPONENTS_POLYFILL).then(function () {
                      _WEB_COMPONENTS_REQUESTED.isDone = true;
                      _WEB_COMPONENTS_REQUESTED.exec();
                    });
                });
        } else {
            loadScript(WEB_COMPONENTS_POLYFILL).then(function () {
              _WEB_COMPONENTS_REQUESTED.isDone = true;
              _WEB_COMPONENTS_REQUESTED.exec();
            });
        }
    } else {
        init();
    }
    
    function getCallbackQueue() {
        var callbacks = [];
        callbacks.isDone = false;
        callbacks.exec = function () {
            callbacks.splice(0).forEach(function (callback) {
                callback();
            });
        };
        callbacks.then = function(callback){
            if (callbacks.isDone) {
                callback();
            } else {
                callbacks.push(callback);
            }
            return callbacks;
        }
        return callbacks;
    }
    
    function loadScript (url) {
        var callbacks = getCallbackQueue();
        var script = DOCUMENT.createElement("script")
        
        script.type = "text/javascript";

        if (script.readyState){ // IE
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                    script.onreadystatechange = null;
                    callbacks.isDone = true;
                    callbacks.exec();
                }
            };
        } else {
            script.onload = function(){
                callbacks.isDone = true;
                callbacks.exec();
            };
        }

        script.src = url;
        DOCUMENT.getElementsByTagName("head")[0].appendChild(script);
        
        script.then = callbacks.then;
        return script;
    }

})(
    "cdnjs.cloudflare.com/ajax/libs",
    "AWAITING_WEB_COMPONENTS_POLYFILL",  // Global wait queue var name
    window,
    document,
    function () {
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["BoxIconElement"] = factory();
	else
		root["BoxIconElement"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__box_icon_element__ = __webpack_require__(2);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BoxIconElement", function() { return __WEBPACK_IMPORTED_MODULE_0__box_icon_element__["a"]; });



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__box_icon_element__["a" /* BoxIconElement */]);

__WEBPACK_IMPORTED_MODULE_0__box_icon_element__["a" /* BoxIconElement */].define();

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoxIconElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_css_animations_css__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_css_animations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_css_animations_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_css_transformations_css__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_css_transformations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_css_transformations_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _fixBabelExtend = function (O) {
  var gPO = O.getPrototypeOf || function (o) {
    return o.__proto__;
  },
      sPO = O.setPrototypeOf || function (o, p) {
    o.__proto__ = p;
    return o;
  },
      construct = (typeof Reflect === 'undefined' ? 'undefined' : _typeof(Reflect)) === 'object' ? Reflect.construct : function (Parent, args, Class) {
    var Constructor,
        a = [null];
    a.push.apply(a, args);
    Constructor = Parent.bind.apply(Parent, a);
    return sPO(new Constructor(), Class.prototype);
  };

  return function fixBabelExtend(Class) {
    var Parent = gPO(Class);
    return sPO(Class, sPO(function Super() {
      return construct(Parent, arguments, gPO(this).constructor);
    }, Parent));
  };
}(Object);

/* global BUILD */



//= ======================================================
var GLOBAL = window;
var CACHE = {}; // iconName: Promise()
var CSS_CLASS_PREFIX = 'bx-';
var CSS_CLASS_PREFIX_ROTATE = CSS_CLASS_PREFIX + 'rotate-';
var CSS_CLASS_PREFIX_FLIP = CSS_CLASS_PREFIX + 'flip-';
var TEMPLATE = document.createElement('template');
var usingShadyCss = function usingShadyCss() {
  return !!GLOBAL.ShadyCSS;
};

TEMPLATE.innerHTML = '\n<style>\n:host {\n  display: inline-block;\n  font-size: initial;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n}\n:host([size=xs]) {\n    width: 0.8rem;\n    height: 0.8rem;\n}\n:host([size=sm]) {\n    width: 1.55rem;\n    height: 1.55rem;\n}\n:host([size=md]) {\n    width: 2.25rem;\n    height: 2.25rem;\n}\n:host([size=lg]) {\n    width: 3.0rem;\n    height: 3.0rem;\n}\n\n:host([size]:not([size=""]):not([size=xs]):not([size=sm]):not([size=md]):not([size=lg])) {\n    width: auto;\n    height: auto;\n}\n:host([pull=left]) #icon {\n    float: left;\n    margin-right: .3em!important;\n}\n:host([pull=right]) #icon {\n    float: right;\n    margin-left: .3em!important;\n}\n:host([border=square]) #icon {\n    padding: .25em;\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: .25em;\n}\n:host([border=circle]) #icon {\n    padding: .25em;\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: 50%;\n}\n#icon,\nsvg {\n  width: 100%;\n  height: 100%;\n}\n#icon {\n    box-sizing: border-box;\n} \n' + __WEBPACK_IMPORTED_MODULE_0__static_css_animations_css___default.a + '\n' + __WEBPACK_IMPORTED_MODULE_1__static_css_transformations_css___default.a + '\n</style>\n<div id="icon"></div>';

/**
 * A Custom Element for displaying icon
 */
var BoxIconElement = _fixBabelExtend(function (_HTMLElement) {
  _inherits(BoxIconElement, _HTMLElement);

  _createClass(BoxIconElement, null, [{
    key: 'getIconSvg',


    /**
     * Returns a promise that should resolve with a string - the svg source.
     *
     * @param {String} iconName
     *  The icon name (file name) to the icon that should be loaded.
     *
     * @return {Promise<String, Error>}
     */
    value: function getIconSvg(iconName, type) {
      var iconUrl = this.cdnUrl + '/regular/bx-' + iconName + '.svg';
      if (type === 'solid') {
        iconUrl = this.cdnUrl + '/solid/bxs-' + iconName + '.svg';
      } else if (type === 'logo') {
        iconUrl = this.cdnUrl + '/logos/bxl-' + iconName + '.svg';
      }
      if (iconUrl && CACHE[iconUrl]) {
        return CACHE[iconUrl];
      }
      CACHE[iconUrl] = new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) {
            reject(new Error(this.status + ' ' + this.responseText));
            return;
          }
          resolve(this.responseText);
        });
        request.onerror = reject;
        request.onabort = reject;
        request.open('GET', iconUrl);
        request.send();
      });
      return CACHE[iconUrl];
    }

    /**
     * Define (register) the custom element
     *
     * @param {String} [tagName=this.tagName]
     */

  }, {
    key: 'define',
    value: function define(tagName) {
      tagName = tagName || this.tagName;
      if (usingShadyCss()) {
        GLOBAL.ShadyCSS.prepareTemplate(TEMPLATE, tagName);
      }
      customElements.define(tagName, this);
    }
  }, {
    key: 'cdnUrl',
    get: function get() {
      // BUILD.DATA.VERSION is injected by webpack during a build.
      // Value is same as package.json#version property.
      return '//unpkg.com/boxicons@' + "2.0.0" + '/svg';
    }
    /**
     * The html tag name to be use
     * @type {String}
     */

  }, {
    key: 'tagName',
    get: function get() {
      return 'box-icon';
    }
  }, {
    key: 'observedAttributes',
    get: function get() {
      return ['type', 'name', 'color', 'size', 'rotate', 'flip', 'animation', 'border', 'pull'];
    }
  }]);

  function BoxIconElement() {
    _classCallCheck(this, BoxIconElement);

    var _this = _possibleConstructorReturn(this, (BoxIconElement.__proto__ || Object.getPrototypeOf(BoxIconElement)).call(this));

    _this.$ui = _this.attachShadow({ mode: 'open' });
    _this.$ui.appendChild(_this.ownerDocument.importNode(TEMPLATE.content, true));
    if (usingShadyCss()) {
      GLOBAL.ShadyCSS.styleElement(_this);
    }
    _this._state = {
      $iconHolder: _this.$ui.getElementById('icon'),
      type: _this.getAttribute('type')
    };
    return _this;
  }

  _createClass(BoxIconElement, [{
    key: 'attributeChangedCallback',
    value: function attributeChangedCallback(attr, oldVal, newVal) {
      var $iconHolder = this._state.$iconHolder;

      switch (attr) {

        case 'type':
          handleTypeChange(this, oldVal, newVal);
          break;
        case 'name':
          handleNameChange(this, oldVal, newVal);
          break;
        case 'color':
          $iconHolder.style.fill = newVal || '';
          break;
        case 'size':
          handleSizeChange(this, oldVal, newVal);
          break;
        case 'rotate':
          if (oldVal) {
            $iconHolder.classList.remove('' + CSS_CLASS_PREFIX_ROTATE + oldVal);
          }
          if (newVal) {
            $iconHolder.classList.add('' + CSS_CLASS_PREFIX_ROTATE + newVal);
          }
          break;
        case 'flip':
          if (oldVal) {
            $iconHolder.classList.remove('' + CSS_CLASS_PREFIX_FLIP + oldVal);
          }
          if (newVal) {
            $iconHolder.classList.add('' + CSS_CLASS_PREFIX_FLIP + newVal);
          }
          break;
        case 'animation':
          if (oldVal) {
            $iconHolder.classList.remove('' + CSS_CLASS_PREFIX + oldVal);
          }
          if (newVal) {
            $iconHolder.classList.add('' + CSS_CLASS_PREFIX + newVal);
          }
          break;
      }
    }
  }, {
    key: 'connectedCallback',
    value: function connectedCallback() {
      if (usingShadyCss()) {
        GLOBAL.ShadyCSS.styleElement(this);
      }
    }
  }]);

  return BoxIconElement;
}(HTMLElement));
function handleTypeChange(inst, oldVal, newVal) {
  var state = inst._state;
  state.$iconHolder.textContent = '';
  if (state.type) {
    state.type = null;
  }

  if (newVal && (newVal === 'solid' || newVal === 'logo')) {
    state.type = newVal;
  } else {
    state.type = 'regular';
  }
  if (state.currentName !== undefined) {
    inst.constructor.getIconSvg(state.currentName, state.type).then(function (iconData) {
      if (state.type === newVal) {
        state.$iconHolder.innerHTML = iconData;
      }
    }).catch(function (error) {
      console.error('Failed to load icon: ' + (state.currentName + "\n") + error); //eslint-disable-line
    });
  }
}
function handleNameChange(inst, oldVal, newVal) {
  var state = inst._state;
  state.currentName = newVal;
  state.$iconHolder.textContent = '';

  if (newVal) {

    if (state.type !== undefined) {
      inst.constructor.getIconSvg(newVal, state.type).then(function (iconData) {
        if (state.currentName === newVal) {
          state.$iconHolder.innerHTML = iconData;
        }
      }).catch(function (error) {
        console.error('Failed to load icon: ' + (newVal + "\n") + error); //eslint-disable-line
      });
    }
  }
}

function handleSizeChange(inst, oldVal, newVal) {
  var state = inst._state;

  if (state.size) {
    state.$iconHolder.style.width = state.$iconHolder.style.height = '';
    state.size = state.sizeType = null;
  }

  // If the size is not one of the short-hand ones, then it must be a
  // css size unit - add it directly to the icon holder.
  if (newVal && !/^(xs|sm|md|lg)$/.test(state.size)) {
    state.size = newVal.trim();
    state.$iconHolder.style.width = state.$iconHolder.style.height = state.size;
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (BoxIconElement);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(4);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@-webkit-keyframes burst{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}90%{-webkit-transform:scale(1.5);transform:scale(1.5);opacity:0}}@keyframes burst{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}90%{-webkit-transform:scale(1.5);transform:scale(1.5);opacity:0}}@-webkit-keyframes flashing{0%{opacity:1}45%{opacity:0}90%{opacity:1}}@keyframes flashing{0%{opacity:1}45%{opacity:0}90%{opacity:1}}@-webkit-keyframes fade-left{0%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}75%{-webkit-transform:translateX(-20px);transform:translateX(-20px);opacity:0}}@keyframes fade-left{0%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}75%{-webkit-transform:translateX(-20px);transform:translateX(-20px);opacity:0}}@-webkit-keyframes fade-right{0%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}75%{-webkit-transform:translateX(20px);transform:translateX(20px);opacity:0}}@keyframes fade-right{0%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}75%{-webkit-transform:translateX(20px);transform:translateX(20px);opacity:0}}@-webkit-keyframes fade-up{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}75%{-webkit-transform:translateY(-20px);transform:translateY(-20px);opacity:0}}@keyframes fade-up{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}75%{-webkit-transform:translateY(-20px);transform:translateY(-20px);opacity:0}}@-webkit-keyframes fade-down{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}75%{-webkit-transform:translateY(20px);transform:translateY(20px);opacity:0}}@keyframes fade-down{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}75%{-webkit-transform:translateY(20px);transform:translateY(20px);opacity:0}}@-webkit-keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.95,.95,.95) rotate(-10deg);transform:scale3d(.95,.95,.95) rotate(-10deg)}30%,50%,70%,90%{-webkit-transform:scaleX(1) rotate(10deg);transform:scaleX(1) rotate(10deg)}40%,60%,80%{-webkit-transform:scaleX(1) rotate(-10deg);transform:scaleX(1) rotate(-10deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.95,.95,.95) rotate(-10deg);transform:scale3d(.95,.95,.95) rotate(-10deg)}30%,50%,70%,90%{-webkit-transform:scaleX(1) rotate(10deg);transform:scaleX(1) rotate(10deg)}40%,60%,80%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.bx-spin,.bx-spin-hover:hover{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite}.bx-tada,.bx-tada-hover:hover{-webkit-animation:tada 1.5s ease infinite;animation:tada 1.5s ease infinite}.bx-flashing,.bx-flashing-hover:hover{-webkit-animation:flashing 1.5s infinite linear;animation:flashing 1.5s infinite linear}.bx-burst,.bx-burst-hover:hover{-webkit-animation:burst 1.5s infinite linear;animation:burst 1.5s infinite linear}.bx-fade-up,.bx-fade-up-hover:hover{-webkit-animation:fade-up 1.5s infinite linear;animation:fade-up 1.5s infinite linear}.bx-fade-down,.bx-fade-down-hover:hover{-webkit-animation:fade-down 1.5s infinite linear;animation:fade-down 1.5s infinite linear}.bx-fade-left,.bx-fade-left-hover:hover{-webkit-animation:fade-left 1.5s infinite linear;animation:fade-left 1.5s infinite linear}.bx-fade-right,.bx-fade-right-hover:hover{-webkit-animation:fade-right 1.5s infinite linear;animation:fade-right 1.5s infinite linear}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(6);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".bx-rotate-90{transform:rotate(90deg);-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\"}.bx-rotate-180{transform:rotate(180deg);-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\"}.bx-rotate-270{transform:rotate(270deg);-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\"}.bx-flip-horizontal{transform:scaleX(-1);-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\"}.bx-flip-vertical{transform:scaleY(-1);-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\"}", ""]);

// exports


/***/ })
/******/ ]);
});
    }
);


// WEBPACK FOOTER //
// boxicons.js